export default __webpack_public_path__ + "assets/d89452ee2ccb405784a38d7130f38e14.jpg";